export default __webpack_public_path__ + "static/media/Thumbs.3ef2ce7b.db";